import { Component, Input } from '@angular/core';

type Variant = 'good' | 'info' | 'warn' | 'bad' | 'neutral';

@Component({
  selector: 'payarc-status-badge',
  template: `<span class="pa-badge" [ngClass]="'pa-badge--' + resolvedVariant">{{ label || status }}</span>`,
  styleUrls: ['./payarc-status-badge.component.css'],
  standalone: false
})
export class PayarcStatusBadgeComponent {
  /** raw status string (mapped to a semantic variant automatically) */
  @Input() status = '';
  /** optional display label if different from status */
  @Input() label?: string;
  /** override the auto-mapped variant */
  @Input() variant?: Variant;

  get resolvedVariant(): Variant {
    if (this.variant) { return this.variant; }
    // Normalize '_'/'-' separators to spaces so word-boundary matches also catch
    // underscore-joined API status values (e.g. "failed_to_gateway").
    const v = (this.status || '').toLowerCase().trim().replace(/[_-]+/g, ' ');
    // Negative/bad cases are checked first and with word boundaries so e.g. "inactive" doesn't
    // match the "active" substring in the good-case regex below.
    if (/\b(declined|failed|error|rejected|reject|chargeback|dispute|lost|inactive|unpaid|unapproved|not approved)\b/.test(v)) { return 'bad'; }
    if (/\b(warning|past due|overdue|attention)\b/.test(v)) { return 'warn'; }
    if (/\b(pending|authorized|processing|submitted|review|trial|hold)\b/.test(v)) { return 'info'; }
    if (/\b(approved|settled|success|paid|captured|complete|active|won)\b/.test(v)) { return 'good'; }
    return 'neutral';
  }
}
